import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../PropertyWalkThroughForm/ConfigurePropertyWalkThrough.scss';
import './HomeownerOnboardingComponent.scss';
import File from '../../File';
import Tabs from '../../Tabs';
import Select from '../../Select';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { fetchProperties } from 'src/store/actions/properties';
import { selectProperties } from 'src/store/selectors/properties';
import { selectHomeownerOnboardingFormData } from 'src/store/selectors/HomeownerOnboardingComponent';
import {
  setHomeownerOnboardingFormData,
  saveHomeOwnerOnboarding,
  changeOrdersSequence,
  clearsetHomeownerOnboardingFormData,
  fetchHomeOwnerOnboarding,
  clearHomeOwnerOnboarding,
  onUpdateSuiteOnBoardingFAQsOrder,
  onUpdateSuiteOnBoardingChecklistsOrder,
  onUpdateSuiteOnBoardingKeysOrder,
  onUpdateSuiteOnBoardingOffersOrder,
  onDeleteOrder,
} from 'src/store/actions/HomeownerOnboardingComponent';
import Row from '../../Row';
import Col from '../../Col';
import FontAwesomeIcon from '../../Icon';
import { AddFaqComponent } from './AddFaq';
import { AddChecklistComponent } from './AddChecklist';
import { AddKeyInformation } from './AddKeyInformation';
import { AddOffers } from './AddOffers';
import { selectHomeownerOnboarding } from 'src/store/selectors/HomeownerOnboarding';
import { upload } from 'src/helpers/upLoadHelper';
import { startFormLoading } from 'src/store/actions/loader';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import LoadState from 'src/components/LoadState/LoadState';
import { URLValidation } from 'src/helpers/validationHelper';
import TextEditor from '../../Editor/Editor';
import { Colors } from 'src/Tenants';
import OnboardingOrders from './OnboardingOrders';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import Checkbox from '../../Checkbox';
import { S3BucketConfig } from 'src/common/constants';
import Tooltip from 'src/components/Tooltip/Tooltip';

const validEmailRegex =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const HomeownerOnboardingComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector(selectAuthenticatedUser);
  const properties = useSelector(selectProperties);
  const homeownerOnboardingFormData = useSelector(selectHomeownerOnboardingFormData);
  const homeownerOnboarding = useSelector(selectHomeownerOnboarding);
  const loader = useSelector(selectFormLoader);
  const prLoader = useSelector(selectPRLoader);

  const [state, setState] = useState<any>({
    editorState: '',
    videoSummary: '',
    summaryText: '',
    faqTitle: '',
    faqDescription: '',
    checklistTitle: '',
    checklistSubtitle: '',
    name: '',
    department: '',
    email: '',
    phone: '',
    selectedId: null,
    faqValidation: '',
    emailValidationMessage: '',
    checklistValidation: '',
    offerValidation: '',
    sequence: {},
    isEnableReorder: false,
    offerName: '',
    offerDescription: '',
    offerDescriptionEditor: '',
    checklistSubtitleEditor: '',
    offerLink: 'https://',
    offerLable: '',
    selectedOfferImage: [],
    sortingObject: {},
    isLegalRepresentativeInformation: 'no',
    loading: false,
    occupancyRole: '',
  });

  const mergeState = (partial) => setState((prev) => ({ ...prev, ...partial }));

  useEffect(() => {
    dispatch(clearsetHomeownerOnboardingFormData());
    dispatch(clearHomeOwnerOnboarding());
    dispatch(fetchProperties(user.id, user.roles[0].role.name));
  }, []);

  const fetchOrderData = (order) => {
    if (!state.isEnableReorder) {
      mergeState({
        faqTitle: '',
        faqDescription: '',
        checklistTitle: '',
        checklistSubtitle: '',
        name: '',
        department: '',
        email: '',
        phone: '',
        faqValidation: '',
        emailValidationMessage: '',
        checklistValidation: '',
        offerValidation: '',
        isEnableReorder: false,
        offerName: '',
        offerDescription: '',
        offerDescriptionEditor: '',
        checklistSubtitleEditor: '',
        offerLink: 'https://',
        offerLable: '',
        selectedOfferImage: [],
        isLegalRepresentativeInformation: 'no',
        occupancyRole: '',
      });
      mergeState({
        isLegalRepresentativeInformation:
          order.isLegalRepresentativeInformation == true ? 'yes' : 'no',
      });
      if (order.isPostOccupancy === true) {
        mergeState({ occupancyRole: 'PostOccupancy' });
      } else {
        mergeState({ occupancyRole: 'PreOccupancy' });
      }
      let editorState = order.summary ? order.summary : '';
      let videoSummary = order.videoSummary ? order.videoSummary : '';
      let summaryText;
      summaryText = order.summary.replace(/<[^>]+>/g, '');

      mergeState({
        editorState: editorState,
        summaryText: summaryText,
        videoSummary: videoSummary,
      });
      if (order.videoType === 'URL' && order.video) {
        dispatch(setHomeownerOnboardingFormData({
          attachment: [order.video],
        }));
      } else {
        dispatch(setHomeownerOnboardingFormData({
          attachment: [],
        }));
      }
      let offers;
      let checklists;
      if (
        order &&
        order.suiteOnBoardingChecklist &&
        order.suiteOnBoardingChecklist.length > 0
      ) {
        checklists = order.suiteOnBoardingChecklist;
      }
      if (
        order &&
        order.suiteOnBoardingOffers &&
        order.suiteOnBoardingOffers.length > 0
      ) {
        offers = order.suiteOnBoardingOffers.map((offer) => {
          return {
            ...offer,
            description: offer.description,
            descriptionEditor: offer.description,
            image: offer.logo ? offer.logo : '',
            logo: [offer.logo],
          };
        });
      }
      setTimeout(() => {
        dispatch(setHomeownerOnboardingFormData({
          id: order.id,
          suiteOnBoardingTitle: homeownerOnboardingFormData.suiteOnBoardingTitle
            ? homeownerOnboardingFormData.suiteOnBoardingTitle
            : order.suiteOnBoardingTitle
              ? order.suiteOnBoardingTitle
              : '',
          propertyId: order.propertyId,
          title: order.title,
          videoType: order.videoType,
          videoLink: order.videoType === 'Link' ? order.video : '',
          summary: order.summary,
          videoSummary: order.videoSummary,
          faqs: order.suiteOnBoardingFAQs,
          checklists: checklists,
          keys: order.suiteOnboardingKeyInformation,
          offers: offers,
          isLegalRepresentativeInformation:
          state.isLegalRepresentativeInformation,
        }));
        mergeState({ loading: false });
      }, 10);
    }
  };

  const clearStateData = () => {
    mergeState({
      faqTitle: '',
      faqDescription: '',
      checklistTitle: '',
      checklistSubtitle: '',
      name: '',
      department: '',
      email: '',
      phone: '',
      selectedId: null,
      faqValidation: '',
      emailValidationMessage: '',
      checklistValidation: '',
      sequence: {},
      summaryText: '',
      editorState: '',
      videoSummary: '',
      offerValidation: '',
      offerName: '',
      offerDescription: '',
      offerDescriptionEditor: '',
      checklistSubtitleEditor: '',
      offerLink: 'https://',
      offerLable: '',
      selectedOfferImage: [],
      isLegalRepresentativeInformation: 'no',
      occupancyRole: '',
    });
  };

  const onClearData = async () => {
    let propertyId = homeownerOnboardingFormData.propertyId;
    await dispatch(clearsetHomeownerOnboardingFormData());
    if (propertyId) {
      dispatch(setHomeownerOnboardingFormData({ propertyId: propertyId }));
      dispatch(fetchHomeOwnerOnboarding(propertyId));
    }
    clearStateData();
  };

  const onReorder = () => {
    mergeState({ isEnableReorder: !state.isEnableReorder });
    onClearData();
  };

  const selectMultipleItems = (files) => {
    dispatch(setHomeownerOnboardingFormData({
      attachment: files,
      videoType: 'URL',
      isupload: true,
    }));
  };

  const handleDelete = (item, i) => {
    dispatch(setHomeownerOnboardingFormData({ attachment: [] }));
  };

  const onEditorChange1 = (editorState) => {
    mergeState({ videoSummary: editorState });
    dispatch(setHomeownerOnboardingFormData({ videoSummary: editorState }));
  };

  const onSetFaq = (value, type) => {
    mergeState({ [type]: value, faqValidation: '' });
  };

  const onSetchecklist = (value, type) => {
    mergeState({
      [type]: value,
      emailValidationMessage: '',
      checklistValidation: '',
      offerValidation: '',
    });
  };

  const onEditorOfferChange = (editorState) => {
    mergeState({
      offerDescription: editorState,
      offerDescriptionEditor: editorState,
    });
  };

  const onEditorFaqChange = (editorState) => {
    mergeState({
      checklistSubtitle: editorState,
      checklistSubtitleEditor: editorState,
    });
  };

  const onSetEditFaq = (value, type, index) => {
    let filterData = homeownerOnboardingFormData.faqs.map((fq, i) => {
      if (i === index) {
        return { ...fq, [type]: value };
      } else {
        return fq;
      }
    });
    dispatch(setHomeownerOnboardingFormData({ faqs: filterData }));
  };

  const onSetEditchecklists = (value, type, index) => {
    let filterData = homeownerOnboardingFormData.checklists.map((cl, i) => {
      if (i === index) {
        if (type === 'subTitle') {
          return { ...cl, [type]: value, subTitleEditor: value };
        } else {
          return { ...cl, [type]: value };
        }
      } else {
        return cl;
      }
    });
    dispatch(setHomeownerOnboardingFormData({ checklists: filterData }));
  };

  const onSetEditkeys = (value, type, index) => {
    let filterData = homeownerOnboardingFormData.keys.map((cl, i) => {
      if (i === index) {
        return { ...cl, [type]: value };
      } else {
        return cl;
      }
    });
    dispatch(setHomeownerOnboardingFormData({ keys: filterData }));
  };

  const onAddFaq = () => {
    let params = {
      name: state.faqTitle.trim(),
      description: state.faqDescription.trim(),
    };
    if (
      homeownerOnboardingFormData &&
      homeownerOnboardingFormData.faqs &&
      homeownerOnboardingFormData.faqs.length > 0
    ) {
      let validation = homeownerOnboardingFormData.faqs.filter(
        (key) =>
          key.name.toLowerCase() === state.faqTitle.toLowerCase().trim()
      );
      if (validation && validation.length === 0) {
        dispatch(setHomeownerOnboardingFormData({
          faqs: [...homeownerOnboardingFormData.faqs, params],
        }));
        mergeState({ faqTitle: '', faqDescription: '', faqValidation: '' });
      } else {
        mergeState({
          faqValidation:
            'You have already created faq with this question, please use different one.',
        });
      }
    } else {
      dispatch(setHomeownerOnboardingFormData({ faqs: [params] }));
      mergeState({ faqTitle: '', faqDescription: '', faqValidation: '' });
    }
  };

  const handleFaqDelete = (data, index) => {
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.faqs.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.faqs.filter((fq) => fq !== data);
    }
    dispatch(setHomeownerOnboardingFormData({ faqs: filterData }));
  };

  const onSortingFAQ = async (data, index, type) => {
    if (type === 'start') {
      mergeState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        state.sortingObject &&
        state.sortingObject.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: state.sortingObject.id, order: data.order },
            { id: data.id, order: state.sortingObject.order },
          ],
          UserId: user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await dispatch(onUpdateSuiteOnBoardingFAQsOrder(
          params,
          homeownerOnboardingFormData.faqs
        ));
        mergeState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.faqs.map((faq) => {
          if (faq === data) {
            return state.sortingObject;
          } else if (faq === state.sortingObject) {
            return data;
          } else {
            return faq;
          }
        });
        await dispatch(setHomeownerOnboardingFormData({ faqs: sortingData }));
        mergeState({ sortingObject: {} });
      }
    }
  };

  const onSortingChecklist = async (data, index, type) => {
    if (type === 'start') {
      mergeState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        state.sortingObject &&
        state.sortingObject.id !== data.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: state.sortingObject.id, order: data.order },
            { id: data.id, order: state.sortingObject.order },
          ],
          UserId: user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await dispatch(onUpdateSuiteOnBoardingChecklistsOrder(
          params,
          homeownerOnboardingFormData.checklists
        ));
        mergeState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.checklists.map(
          (checklist) => {
            if (checklist === data) {
              return state.sortingObject;
            } else if (checklist === state.sortingObject) {
              return data;
            } else {
              return checklist;
            }
          }
        );
        await dispatch(setHomeownerOnboardingFormData({ checklists: sortingData }));
        mergeState({ sortingObject: {} });
      }
    }
  };

  const onSortingKey = async (data, index, type) => {
    if (type === 'start') {
      mergeState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        state.sortingObject &&
        state.sortingObject.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: state.sortingObject.id, order: data.order },
            { id: data.id, order: state.sortingObject.order },
          ],
          UserId: user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await dispatch(onUpdateSuiteOnBoardingKeysOrder(
          params,
          homeownerOnboardingFormData.keys
        ));
        mergeState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.keys.map((key) => {
          if (key === data) {
            return state.sortingObject;
          } else if (key === state.sortingObject) {
            return data;
          } else {
            return key;
          }
        });
        await dispatch(setHomeownerOnboardingFormData({ keys: sortingData }));
        mergeState({ sortingObject: {} });
      }
    }
  };

  const onSortingOffers = async (data, index, type) => {
    if (type === 'start') {
      mergeState({ sortingObject: data });
    } else {
      if (
        data &&
        data.id &&
        state.sortingObject &&
        state.sortingObject.id
      ) {
        let params = {
          SuiteOnBoardingOrder: [
            { id: state.sortingObject.id, order: data.order },
            { id: data.id, order: state.sortingObject.order },
          ],
          UserId: user.id,
          SuiteOnboardingId: homeownerOnboardingFormData.id,
        };
        await dispatch(onUpdateSuiteOnBoardingOffersOrder(
          params,
          homeownerOnboardingFormData.offers
        ));
        mergeState({ sortingObject: {} });
      } else {
        let sortingData = homeownerOnboardingFormData.offers.map((offer) => {
          if (offer === data) {
            return state.sortingObject;
          } else if (offer === state.sortingObject) {
            return data;
          } else {
            return offer;
          }
        });
        await dispatch(setHomeownerOnboardingFormData({ offers: sortingData }));
        mergeState({ sortingObject: {} });
      }
    }
  };

  const handleChecklistDelete = (data) => {
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.checklists.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.checklists.filter(
        (fq) => fq !== data
      );
    }
    dispatch(setHomeownerOnboardingFormData({ checklists: filterData }));
  };

  const handlekeyDelete = (data) => {
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.keys.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.keys.filter((fq) => fq !== data);
    }
    dispatch(setHomeownerOnboardingFormData({ keys: filterData }));
  };

  const handleOfferDelete = (data) => {
    let filterData;
    if (data && data.id) {
      filterData = homeownerOnboardingFormData.offers.map((cl, i) => {
        if (data.id === cl.id) {
          return { ...cl, isdeleted: true };
        } else {
          return cl;
        }
      });
    } else {
      filterData = homeownerOnboardingFormData.offers.filter(
        (fq) => fq !== data
      );
    }
    dispatch(setHomeownerOnboardingFormData({ offers: filterData }));
  };

  const onAddchecklist = () => {
    let params = {
      title: state.checklistTitle.trim(),
      subTitle: state.checklistSubtitle
        ? state.checklistSubtitle
        : '',
      subTitleEditor: state.checklistSubtitleEditor
        ? state.checklistSubtitleEditor
        : '',
    };
    if (
      homeownerOnboardingFormData &&
      homeownerOnboardingFormData.checklists &&
      homeownerOnboardingFormData.checklists.length > 0
    ) {
      let validation = homeownerOnboardingFormData.checklists.filter(
        (key) =>
          key.title.toLowerCase() ===
          state.checklistTitle.toLowerCase().trim()
      );
      if (validation && validation.length === 0) {
        dispatch(setHomeownerOnboardingFormData({
          checklists: [...homeownerOnboardingFormData.checklists, params],
        }));
        mergeState({
          checklistTitle: '',
          checklistSubtitle: '',
          checklistValidation: '',
          checklistSubtitleEditor: '',
        });
      } else {
        mergeState({
          checklistValidation:
            'You have already created checklist with this title, please use different one.',
        });
      }
    } else {
      dispatch(setHomeownerOnboardingFormData({ checklists: [params] }));
      mergeState({
        checklistTitle: '',
        checklistSubtitle: '',
        checklistValidation: '',
        checklistSubtitleEditor: '',
      });
    }
  };

  const onAddkeys = () => {
    let params = {
      name: state.name.trim(),
      department: state.department ? state.department.trim() : '',
      email: state.email.trim(),
      phone: state.phone,
    };
    if (state.email == null || state.email == '') {
      dispatch(setHomeownerOnboardingFormData({
        keys: [...homeownerOnboardingFormData.keys, params],
      }));
      mergeState({
        name: '',
        department: '',
        email: '',
        emailValidationMessage: '',
        phone: '',
      });
    } else {
      if (validEmailRegex.test(state.email.toLowerCase())) {
        if (
          homeownerOnboardingFormData &&
          homeownerOnboardingFormData.keys &&
          homeownerOnboardingFormData.keys.length > 0
        ) {
          let validation = homeownerOnboardingFormData.keys.filter(
            (key) =>
              key.email.toLowerCase() === state.email.toLowerCase().trim()
          );
          if (validation && validation.length === 0) {
            dispatch(setHomeownerOnboardingFormData({
              keys: [...homeownerOnboardingFormData.keys, params],
            }));
            mergeState({
              name: '',
              department: '',
              email: '',
              emailValidationMessage: '',
              phone: '',
            });
          } else {
            mergeState({
              emailValidationMessage:
                'You have already created key contact with this email, please use different one.',
            });
          }
        } else {
          dispatch(setHomeownerOnboardingFormData({ keys: [params] }));
          mergeState({
            name: '',
            department: '',
            email: '',
            emailValidationMessage: '',
            phone: '',
          });
        }
      } else {
        mergeState({
          emailValidationMessage: 'Please enter a valid email address.',
        });
      }
    }
  };

  // function to upload the images into aws
  const uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile);
    callback(imageUrl);
  };

  const isValidURL = (string) => {
    var res = string.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    return res !== null;
  };

  const checkValidation = (data) => {
    let array = [];
    data.map((obj) => {
      if (obj) {
        array = [...array, obj];
      } else {
      }
    });
    return array;
  };

  const handleSave = async () => {
    let data = state;
    let isValidUrl = true;
    var isDuplicateFaq = false;
    var isDuplicateChecklist = false;
    var isDuplicatekey = false;

    var emailKeyValidation = [];
    var faqs = homeownerOnboardingFormData.faqs
      ? homeownerOnboardingFormData.faqs
      : [];
    var checklists = homeownerOnboardingFormData.checklists
      ? homeownerOnboardingFormData.checklists
      : [];
    var keys = homeownerOnboardingFormData.keys
      ? homeownerOnboardingFormData.keys
      : [];
    var offers = homeownerOnboardingFormData.offers
      ? homeownerOnboardingFormData.offers
      : [];
    var faqValidation;
    var checklistValidation;
    var emailValidationMessage;
    var offerValidation;

    var faqData =
      data.faqTitle &&
      data.faqTitle.trim() &&
      data.faqDescription &&
      data.faqDescription.trim();
    var keyData = data.name && data.name.trim();
    var offerData =
      data.offerName &&
      data.offerName.trim() &&
      data.offerLink &&
      data.offerLink.trim() &&
      data.offerLable &&
      data.offerLable.trim() &&
      data.selectedOfferImage.length > 0;

    var faqCheckValidation = checkValidation([
      data.faqTitle.trim(),
      data.faqDescription.trim(),
    ]);
    var keyCheckValidation = checkValidation([
      data.name.trim(),
      data.department,
      data.email,
      data.phone,
    ]);

    var offerCheckValidation = checkValidation([
      data.offerName.trim(),
      data.offerLink.trim() === 'https://' ? '' : data.offerLink.trim(),
      data.offerLable.trim(),
      data.selectedOfferImage.length > 0 ? data.selectedOfferImage[0] : '',
    ]);

    var faqFormChecking = faqData
      ? false
      : faqCheckValidation.length > 0;

    var keysFormChecking = keyData
      ? false
      : keyCheckValidation.length > 0;

    var offerFormChecking = offerData
      ? false
      : offerCheckValidation.length > 0;

    if (faqFormChecking) {
      alert(
        'There is incomplete data in the Faq section, please update it before saving. Thank you.'
      );
    } else if (keysFormChecking) {
      alert(
        'There is incomplete data in the Key contact section, please update it before saving. Thank you.'
      );
    } else if (offerFormChecking) {
      alert(
        'There is incomplete data in the Offers section, please update it before saving. Thank you.'
      );
    } else {
      if (
        data.faqTitle &&
        data.faqTitle.trim() &&
        data.faqDescription &&
        data.faqDescription.trim()
      ) {
        let params = {
          name: state.faqTitle.trim(),
          description: state.faqDescription.trim(),
        };
        if (faqs && faqs.length > 0) {
          let validation = faqs.filter(
            (key) =>
              key.name.toLowerCase() ===
              state.faqTitle.toLowerCase().trim()
          );
          if (validation && validation.length === 0) {
            faqs = [...faqs, params];
            mergeState({
              faqTitle: '',
              faqDescription: '',
              faqValidation: '',
            });
          } else {
            faqValidation =
              'You have already created faq with this question, please use different one.';
            mergeState({
              faqValidation:
                'You have already created faq with this question, please use different one.',
            });
          }
        } else {
          faqs = [params];
          mergeState({
            faqTitle: '',
            faqDescription: '',
            faqValidation: '',
          });
        }
      }
      if (data.checklistTitle && data.checklistTitle.trim()) {
        let params = {
          title: state.checklistTitle.trim(),
          subTitle: state.checklistSubtitle
            ? state.checklistSubtitle
            : '',
          subTitleEditor: state.checklistSubtitleEditor
            ? state.checklistSubtitleEditor
            : '',
        };

        if (checklists && checklists.length > 0) {
          let validation = checklists.filter(
            (key: any) =>
              key.title.toLowerCase() ===
              state.checklistTitle.toLowerCase().trim()
          );

          if (validation && validation.length === 0) {
            checklists = [...checklists, params];
            mergeState({
              checklistTitle: '',
              checklistSubtitle: '',
              checklistValidation: '',
              checklistSubtitleEditor: '',
            });
          } else {
            checklistValidation =
              'You have already created checklist with this title, please use different one.';
            mergeState({
              checklistValidation:
                'You have already created checklist with this title, please use different one.',
            });
          }
        } else {
          checklists = [params];
          mergeState({
            checklistTitle: '',
            checklistSubtitle: '',
            checklistValidation: '',
            checklistSubtitleEditor: '',
          });
        }
      }
      if (data.name && data.name.trim()) {
        let params = {
          name: state.name.trim(),
          department: state.department ? state.department.trim() : '',
          email: state.email.trim(),
          phone: state.phone,
        };
        if (state.email == null || state.email == '') {
          keys = [...keys, params];
          mergeState({
            name: '',
            department: '',
            email: '',
            emailValidationMessage: '',
            phone: '',
          });
        } else {
          if (validEmailRegex.test(state.email.toLowerCase())) {
            if (keys && keys.length > 0) {
              let validation = keys.filter(
                (key: any) =>
                  key.email.toLowerCase() ===
                  state.email.toLowerCase().trim()
              );
              if (validation && validation.length === 0) {
                keys = [...keys, params];
                mergeState({
                  name: '',
                  department: '',
                  email: '',
                  emailValidationMessage: '',
                  phone: '',
                });
              } else {
                emailValidationMessage =
                  'You have already created key contact with this email, please use different one.';
                mergeState({
                  emailValidationMessage:
                    'You have already created key contact with this email, please use different one.',
                });
              }
            } else {
              keys = [params];
              mergeState({
                name: '',
                department: '',
                email: '',
                emailValidationMessage: '',
                phone: '',
              });
            }
          } else {
            emailValidationMessage = 'Please enter a valid email address.';
            mergeState({
              emailValidationMessage: 'Please enter a valid email address.',
            });
          }
        }
      }
      if (
        data.offerName &&
        data.offerName.trim() &&
        data.offerLink &&
        data.offerLink.trim() &&
        data.offerLable &&
        data.offerLable.trim() &&
        data.selectedOfferImage.length > 0
      ) {
        var isofferValidUrl = true;
        if (state.offerLink) {
          var testCase = state.offerLink;
          isofferValidUrl = URLValidation(testCase);
        }
        if (isofferValidUrl === null) {
          offerValidation =
            'You have given invalid link, please provide a valid link.';
        } else {
          let params = {
            name: state.offerName.trim(),
            description: state.offerDescription,
            descriptionEditor: state.offerDescriptionEditor,
            linkName: isofferValidUrl[0],
            linkURL: state.offerLable.trim(),
            logo: state.selectedOfferImage,
          };

          if (offers && offers.length > 0) {
            let validation = offers.filter(
              (key) =>
                key.name.toLowerCase() ===
                state.offerName.toLowerCase().trim()
            );
            if (validation && validation.length === 0) {
              offers = [...offers, params];
              mergeState({
                offerName: '',
                offerDescription: '',
                offerDescriptionEditor: '',
                offerLink: 'https://',
                offerLable: '',
                offerValidation: '',
                selectedOfferImage: [],
              });
            } else {
              offerValidation =
                'You have already created offer with this name, please use different one.';
              mergeState({
                offerValidation:
                  'You have already created offer with this name, please use different one.',
              });
            }
          } else {
            offers = [params];
            mergeState({
              offerName: '',
              offerDescription: '',
              offerLable: '',
              offerLink: 'https://',
              offerValidation: '',
              selectedOfferImage: [],
            });
          }
        }
      }

      if (
        homeownerOnboardingFormData &&
        homeownerOnboardingFormData.videoLink
      ) {
        let testCase = homeownerOnboardingFormData.videoLink;
      }
      if (faqs && faqs.length > 0) {
        var faqArr = faqs.map(function (item) {
          return item.name.toLowerCase();
        });
        isDuplicateFaq = faqArr.some(function (item, idx) {
          return faqArr.indexOf(item) !== idx;
        });
      }
      var filteredChecklists = [];

      if (checklists && checklists.length > 0) {
        filteredChecklists = checklists.map(
          ({ subTitleEditor, ...rest }) => rest
        );

        var checklistArr = filteredChecklists.map(function (item) {
          return item.title.toLowerCase();
        });

        isDuplicateChecklist = checklistArr.some(function (item, idx) {
          return checklistArr.indexOf(item) !== idx;
        });
      }


      let filteredOffers = [];

      if (offers && offers.length > 0) {
        let result = offers.map(({ descriptionEditor, ...rest }) => rest);

        for (var i = 0; i < result.length; i++) {
          let offerObj = result[i];

          if (offerObj && offerObj.logo) {
            if (
              offerObj &&
              offerObj.image &&
              offerObj.image.search(S3BucketConfig.url) !== -1
            ) {
              let imageUrl = offerObj.image;
              filteredOffers = [
                ...filteredOffers,
                { ...offerObj, logo: imageUrl },
              ];
            } else {
              let imageUrl = await upload(offerObj.logo[0]);
              filteredOffers = [
                ...filteredOffers,
                { ...offerObj, logo: imageUrl },
              ];
            }
          } else {
            filteredOffers = [...filteredOffers, { ...offerObj, logo: '' }];
          }
        }
      }

      if (faqValidation) {
        alert(faqValidation);
      } else if (checklistValidation) {
        alert(checklistValidation);
      } else if (emailValidationMessage) {
        alert(emailValidationMessage);
      } else if (offerValidation) {
        alert(offerValidation);
      } else if (isDuplicateFaq) {
        alert('You have added duplicate faq, please validate.');
      } else if (isDuplicateChecklist) {
        alert('You have added duplicate checklist, please validate.');
      } else if (emailKeyValidation && emailKeyValidation.length > 0) {
        alert('Please enter a valid email address.');
      } else if (isDuplicatekey) {
        alert('You have added duplicate key contact, please validate.');
      } else {
        const { occupancyRole } = state;
        const params: any = {
          SuiteOnBoardingTitle: homeownerOnboardingFormData.suiteOnBoardingTitle
            ? homeownerOnboardingFormData.suiteOnBoardingTitle
            : '',
          Title: homeownerOnboardingFormData.title.trim(),
          Video: '',
          VideoType: homeownerOnboardingFormData.videoType,
          Summary: homeownerOnboardingFormData.summary
            ? homeownerOnboardingFormData.summary
            : '',
          PropertyId: homeownerOnboardingFormData.propertyId,
          UserId: user.id,
          SuiteOnBoardingFAQs: faqs,
          SuiteOnBoardingChecklist: filteredChecklists,
          SuiteOnboardingKeyInformation: keys,
          SuiteOnboardingOffers: filteredOffers,
          IsLegalRepresentativeInformation:
            state.isLegalRepresentativeInformation === 'yes',
          IsPostOccupancy: occupancyRole === 'PostOccupancy',
        };

        if (homeownerOnboardingFormData && homeownerOnboardingFormData.id) {
          params.id = homeownerOnboardingFormData.id;
        }
        let imageUrl;
        if (
          homeownerOnboardingFormData &&
          homeownerOnboardingFormData.attachment &&
          homeownerOnboardingFormData.attachment.length > 0
        ) {
          if (homeownerOnboardingFormData.isupload) {
            dispatch(startFormLoading());
            imageUrl = await upload(homeownerOnboardingFormData.attachment[0]);
          } else {
            imageUrl = homeownerOnboardingFormData.attachment[0];
          }
          params.Video = imageUrl;
          params.VideoSummary =
            homeownerOnboardingFormData.videoSummary || state.videoSummary;
          await dispatch(saveHomeOwnerOnboarding(params));
          mergeState({
            editorState: '',
            summaryText: '',
            videoSummary: '',
            selectedId: null,
          });
          clearStateData();
        } else {
          params.Video =
            homeownerOnboardingFormData &&
            homeownerOnboardingFormData.videoLink &&
            homeownerOnboardingFormData.videoLink.trim()
              ? homeownerOnboardingFormData.videoLink.trim()
              : '';
          params.VideoSummary =
            homeownerOnboardingFormData.videoSummary || state.videoSummary;
          await dispatch(saveHomeOwnerOnboarding(params));
          mergeState({
            editorState: '',
            summaryText: '',
            videoSummary: '',
            selectedId: null,
          });
          clearStateData();
        }
      }
    }
  };

  const onDropSequence = (areaData, i) => {
    let data = {
      SuiteOnBoardingOrder: [
        {
          id: state.sequence.id,
          Order: i,
        },
        {
          id: areaData.id,
          Order: state.sequence.order,
        },
      ],
      PropertyId: homeownerOnboardingFormData.propertyId,
      UserId: user.id,
    };
    dispatch(changeOrdersSequence(data));
    mergeState({ sequence: {} });
  };

  const onSelectProperty = async (value) => {
    dispatch(clearsetHomeownerOnboardingFormData());
    await dispatch(fetchHomeOwnerOnboarding(value));
    dispatch(setHomeownerOnboardingFormData({ propertyId: value }));
    mergeState({
      faqTitle: '',
      faqDescription: '',
      checklistTitle: '',
      checklistSubtitle: '',
      name: '',
      department: '',
      email: '',
      phone: '',
      selectedId: null,
      faqValidation: '',
      emailValidationMessage: '',
      checklistValidation: '',
      sequence: {},
      summaryText: '',
      editorState: '',
      videoSummary: '',
      offerValidation: '',
      offerName: '',
      offerDescription: '',
      offerDescriptionEditor: '',
      checklistSubtitleEditor: '',
      offerLink: 'https://',
      offerLable: '',
      selectedOfferImage: [],
    });
  };

  const onAddOffer = () => {
    var isValidUrl = true;
    if (state.offerLink) {
      var testCase = state.offerLink;
      isValidUrl = URLValidation(testCase);
    }
    if (isValidUrl === null) {
      alert('You have given invalid link, please provide a valid link.');
    } else {
      let params = {
        name: state.offerName.trim(),
        description: state.offerDescription,
        descriptionEditor: state.offerDescriptionEditor,
        linkName: isValidUrl[0],
        linkURL: state.offerLable.trim(),
        logo: state.selectedOfferImage,
      };

      if (
        homeownerOnboardingFormData &&
        homeownerOnboardingFormData.offers &&
        homeownerOnboardingFormData.offers.length > 0
      ) {
        let validation = homeownerOnboardingFormData.offers.filter(
          (key) =>
            key.name.toLowerCase() === state.offerName.toLowerCase().trim()
        );
        if (validation && validation.length === 0) {
          dispatch(setHomeownerOnboardingFormData({
            offers: [...homeownerOnboardingFormData.offers, params],
          }));
          mergeState({
            offerName: '',
            offerDescription: '',
            offerDescriptionEditor: '',
            offerLink: 'https://',
            offerLable: '',
            offerValidation: '',
            selectedOfferImage: [],
          });
        } else {
          mergeState({
            offerValidation:
              'You have already created offer with this name, please use different one.',
          });
        }
      } else {
        dispatch(setHomeownerOnboardingFormData({ offers: [params] }));
        mergeState({
          offerName: '',
          offerDescription: '',
          offerLable: '',
          offerLink: 'https://',
          offerValidation: '',
          selectedOfferImage: [],
        });
      }
    }
  };

  const onSetEditOffer = (value, type, index) => {
    let filterData = homeownerOnboardingFormData.offers.map((cl, i) => {
      if (i === index) {
        if (type === 'description') {
          return { ...cl, [type]: value, descriptionEditor: value };
        } else {
          if (type === 'logo' && cl && cl.image) {
            return { ...cl, [type]: value, image: null };
          } else {
            return { ...cl, [type]: value };
          }
        }
      } else {
        return cl;
      }
    });
    dispatch(setHomeownerOnboardingFormData({ offers: filterData }));
  };

  const handleNumKeys = (event) => {
    if (
      (event.charCode > 31 && event.charCode < 48) ||
      (event.charCode > 57 && event.charCode < 127)
    ) {
      event.preventDefault();
    }
  };

  const onClearFormData = (type) => {
    if (type === 'faq') {
      mergeState({ faqTitle: '', faqDescription: '', faqValidation: '' });
    } else if (type === 'checklist') {
      mergeState({
        checklistTitle: '',
        checklistSubtitle: '',
        checklistValidation: '',
        checklistSubtitleEditor: '',
      });
    } else if (type === 'key') {
      mergeState({
        name: '',
        department: '',
        email: '',
        emailValidationMessage: '',
        phone: '',
      });
    } else {
      mergeState({
        offerName: '',
        offerDescription: '',
        offerDescriptionEditor: '',
        offerLink: 'https://',
        offerLable: '',
        offerValidation: '',
        selectedOfferImage: [],
      });
    }
  };

  const onDeleteUsersOrder = async (orderId) => {
    await dispatch(onDeleteOrder(orderId, user.id));
    onClearData();
  };

  let validation =
    homeownerOnboardingFormData.propertyId &&
    homeownerOnboardingFormData.title &&
    homeownerOnboardingFormData.title.trim();
  const { occupancyRole } = state;

  const isLoading: boolean = loader || prLoader || state.loading;

  return (
    <div className="header_section">
      <div className="header_box">
        <div className="configure_heading">
          <h2 style={{ marginBottom: 0 }}>Home Owner Onboarding</h2>
        </div>
        <div
          class="next_btn text-right"
          // @ts-ignore
          style={{ pointerEvents: !validation && 'none', cursor: 'pointer' }}
          onClick={() => handleSave()}
        >
          <a>Save</a>
        </div>
      </div>
      <LoadState isLoading={isLoading}>
      <Row>
        <Col md={8} xs={12}>
          <div>
            <div className="select-dropdown">
              <Select
                value={
                  homeownerOnboardingFormData &&
                  homeownerOnboardingFormData.propertyId
                    ? homeownerOnboardingFormData.propertyId
                    : ''
                }
                onChange={(e) => {
                  dispatch(
                    setHomeownerOnboardingFormData({
                      propertyId: e.target.value,
                    })
                  );
                  onSelectProperty(e.target.value);
                }}
                options={properties.map((pty) => ({
                  value: pty.id,
                  label: `${pty.name}`,
                }))}
                placeholder="Select Property"
                block
              />
            </div>
            <div className="homeOwnercard">
              <div className="input_box">
                <div className="homeOwnerinput_section homeOwnerinputContainer">
                  <div className="mt-10 onboardingTitleInputLable xs-12">
                    <div className="input__require">
                      <label className="input__label">Onboarding title:</label>
                    </div>
                  </div>
                  <div className="onboardingTitleInputForm xs-12">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Add a Title"
                      aria-label="default input example"
                      value={
                        homeownerOnboardingFormData.suiteOnBoardingTitle
                          ? homeownerOnboardingFormData.suiteOnBoardingTitle
                          : ''
                      }
                      onChange={(e) =>
                        dispatch(
                          setHomeownerOnboardingFormData({
                            suiteOnBoardingTitle: e.target.value,
                          })
                        )
                      }
                      maxLength={30}
                    />
                  </div>
                </div>
                <div className="homeOwnerinput_section homeOwnerinputContainer">
                  <div className="mt-10 inputLable">
                    <div className="input__require">
                      <label className="input__label">Title:</label>
                      <div className="input__required" />
                    </div>
                  </div>
                  <div className="inputForm">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Add a Title"
                      aria-label="default input example"
                      value={
                        homeownerOnboardingFormData.title
                          ? homeownerOnboardingFormData.title
                          : ''
                      }
                      onChange={(e) =>
                        dispatch(
                          setHomeownerOnboardingFormData({
                            title: e.target.value,
                          })
                        )
                      }
                      required
                      disabled={!homeownerOnboardingFormData?.propertyId}
                    />
                  </div>
                </div>
                <div className="homeOwnerinput_section homeOwnerinputContainer">
                  <div className="mt-10 inputLable" style={{ display: 'flex', alignItems: 'center' }}>
                    <label className="input__label">YouTube or Vimeo Embed Link:</label>
                    <Tooltip content="On YouTube: Share → Embed. On Vimeo: Share → Embed. Paste the full iframe src URL here.">
                      <FontAwesomeIcon
                        glyph="info-circle"
                        weight="light"
                        size="small"
                        style={{ marginLeft: 6, color: '#a1a1a1', cursor: 'pointer' }}
                      />
                    </Tooltip>
                  </div>
                  <div className="inputForm">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Paste a YouTube or Vimeo embed URL"
                      aria-label="default input example"
                      value={
                        homeownerOnboardingFormData.videoLink
                          ? homeownerOnboardingFormData.videoLink
                          : ''
                      }
                      onChange={(e) =>
                        dispatch(
                          setHomeownerOnboardingFormData({
                            videoLink: e.target.value,
                            videoType: 'Link',
                          })
                        )
                      }
                      required
                    />
                  </div>
                </div>
                <div className="orWidth">
                  <p>or</p>
                </div>
                <div
                  className="homeOwnerinput_section homeOwnerinputContainer"
                  style={{ width: '100%', marginLeft: '12px' }}
                >
                  <div className="mt-10 inputLable"> </div>
                  <div className="inputForm">
                    <File
                      label=""
                      type={['video', 'image']}
                      onSelect={(file) => selectMultipleItems(file)}
                      files={[]}
                      multiSelect={false}
                    />
                  </div>
                </div>
                <div
                  className="input homeOwnerinput_section homeOwnerinputContainer"
                  style={{ width: '100%', marginLeft: '12px' }}
                >
                  <div className="mt-10 inputLable"> </div>
                  <div className="inputForm">
                    {homeownerOnboardingFormData.attachment?.length > 0
                      ? homeownerOnboardingFormData.attachment.map(
                          (data, i) => (
                            <div
                              style={{
                                marginRight: 40,
                                marginTop: -20,
                                marginBottom: 10,
                              }}
                            >
                              <Row granola>
                                <Col granola xs="12" md="11">
                                  <div style={{ wordBreak: 'break-all' }}>
                                    {data && data.path
                                      ? data.path
                                      : data.split('.com/')[1]}
                                  </div>
                                </Col>
                                <Col granola xs="12" md="1">
                                  <div
                                    className="videoText"
                                    onClick={() => handleDelete(data, i)}
                                  >
                                    <FontAwesomeIcon
                                      glyph="times-circle"
                                      weight="light"
                                      size="small"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          )
                        )
                      : null}
                  </div>
                </div>
                <div
                  className="input homeOwnerinput_section homeOwnerinputContainer"
                  style={{ width: '100%', marginLeft: '12px' }}
                >
                  <div className="mt-10 inputLable">Summary: </div>
                  <div className="inputForm">
                    <div
                      style={{
                        border: '0.1rem solid rgba(83, 83, 83, 0.25)',
                        borderRadius: '5px',
                        padding: '0px',
                      }}
                      className="input__control"
                    >
                      <TextEditor
                        editorState={state.videoSummary}
                        placeholder="Summary"
                        onEditorStateChange={onEditorChange1}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="input homeOwnerinput_section homeOwnerinputContainer"
                  style={{ marginLeft: '12px', marginTop: '25px' }}
                >
                  <Checkbox
                    value={occupancyRole === 'PostOccupancy' ? false : true}
                    label="Display for pre-occupancy"
                    onChange={() =>
                      mergeState({ occupancyRole: 'PreOccupancy' })
                    }
                  />
                </div>
                <div
                  className="input homeOwnerinput_section homeOwnerinputContainer"
                  style={{ marginLeft: '12px', marginTop: '25px' }}
                >
                  <Checkbox
                    value={occupancyRole === 'PostOccupancy' ? true : false}
                    label="Display for post occupancy"
                    onChange={() =>
                      mergeState({ occupancyRole: 'PostOccupancy' })
                    }
                  />
                </div>
                <div
                  className="input homeOwnerinput_section homeOwnerinputContainer"
                  style={{ marginLeft: '12px', marginTop: '25px' }}
                >
                  Do you want the Homeowner to add legal representation form
                  ?&nbsp;&nbsp;&nbsp;
                  <span
                    onClick={() =>
                      mergeState({
                        isLegalRepresentativeInformation: 'yes',
                      })
                    }
                    style={
                      state.isLegalRepresentativeInformation == 'yes'
                        ? {
                            backgroundColor: Colors.toggleAndButtonColor,
                            width: '10%',
                            height: '25px',
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            lineHeight: '25px',
                            borderTopLeftRadius: '5px',
                            borderBottomLeftRadius: '5px',
                            cursor: 'pointer',
                          }
                        : {
                            backgroundColor: '#F2F2F2',
                            width: '10%',
                            height: '25px',
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                            lineHeight: '25px',
                            borderTopLeftRadius: '5px',
                            borderBottomLeftRadius: '5px',
                            color: '#36396D',
                            cursor: 'pointer',
                          }
                    }
                  >
                    Yes
                  </span>
                  <span
                    onClick={() =>
                      mergeState({
                        isLegalRepresentativeInformation: 'no',
                      })
                    }
                    style={
                      state.isLegalRepresentativeInformation == 'no'
                        ? {
                            backgroundColor: Colors.toggleAndButtonColor,
                            width: '10%',
                            height: '25px',
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                            lineHeight: '25px',
                            borderTopRightRadius: '5px',
                            borderBottomRightRadius: '5px',
                            cursor: 'pointer',
                          }
                        : {
                            backgroundColor: '#F2F2F2',
                            width: '10%',
                            height: '25px',
                            textAlign: 'center',
                            justifyContent: 'center',
                            alignItems: 'center',
                            lineHeight: '25px',
                            borderTopRightRadius: '5px',
                            borderBottomRightRadius: '5px',
                            color: '#36396D',
                            cursor: 'pointer',
                          }
                    }
                  >
                    No
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col md={4} xs={12}>
          <OnboardingOrders
            homeownerOnboarding={homeownerOnboarding}
            onClearData={onClearData}
            selectedId={state.selectedId}
            isEnableReorder={state.isEnableReorder}
            onReorder={onReorder}
            fetchOrderData={(area) => {
              mergeState({ loading: true });
              fetchOrderData(area);
              mergeState({
                selectedId: state.isEnableReorder ? null : area.id,
              });
            }}
            onDropSequence={(area, i) => onDropSequence(area, i)}
            onDeleteOrder={onDeleteUsersOrder}
            onDragStart={(area) =>
              mergeState({
                sequence: state.isEnableReorder ? area : {},
              })
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} xs={12}>
          <div className="homeOwnerTabs">
            <Tabs
              items={[
                {
                  label: 'FAQ',
                  content: (
                    <AddFaqComponent
                      faqs={
                        homeownerOnboardingFormData &&
                        homeownerOnboardingFormData.faqs
                          ? homeownerOnboardingFormData.faqs
                          : []
                      }
                      onSetFaq={onSetFaq}
                      onSetEditFaq={onSetEditFaq}
                      data={state}
                      onAddFaq={onAddFaq}
                      handleFaqDelete={handleFaqDelete}
                      onSortingFAQ={onSortingFAQ}
                      orderId={
                        homeownerOnboardingFormData.id
                          ? homeownerOnboardingFormData.id
                          : ''
                      }
                      onClearFormData={onClearFormData}
                    />
                  ),
                },
                {
                  label: 'CHECKLIST',
                  content: (
                    <AddChecklistComponent
                      checklists={
                        homeownerOnboardingFormData &&
                        homeownerOnboardingFormData.checklists
                          ? homeownerOnboardingFormData.checklists
                          : []
                      }
                      onSetFaq={onSetchecklist}
                      onSetEditFaq={onSetEditchecklists}
                      data={state}
                      onAddFaq={onAddchecklist}
                      handleChecklistDelete={handleChecklistDelete}
                      onSortingChecklist={onSortingChecklist}
                      onEditorFaqChange={onEditorFaqChange}
                      onClearFormData={onClearFormData}
                    />
                  ),
                },
                {
                  label: 'KEY CONTACT',
                  content: (
                    <AddKeyInformation
                      keys={
                        homeownerOnboardingFormData &&
                        homeownerOnboardingFormData.keys
                          ? homeownerOnboardingFormData.keys
                          : []
                      }
                      onSetKey={onSetchecklist}
                      onSetEditKey={onSetEditkeys}
                      data={state}
                      onAddKey={onAddkeys}
                      handleKeyPress={handleNumKeys}
                      handlekeyDelete={handlekeyDelete}
                      onSortingKey={onSortingKey}
                      onClearFormData={onClearFormData}
                    />
                  ),
                },
                {
                  label: 'OFFERS',
                  content: (
                    <AddOffers
                      offers={
                        homeownerOnboardingFormData &&
                        homeownerOnboardingFormData.offers
                          ? homeownerOnboardingFormData.offers
                          : []
                      }
                      onSetOffer={onSetchecklist}
                      onSetEditOffer={onSetEditOffer}
                      data={state}
                      onAddOffer={onAddOffer}
                      handleOfferDelete={handleOfferDelete}
                      onEditorOfferChange={onEditorOfferChange}
                      onSortingOffers={onSortingOffers}
                      onClearFormData={onClearFormData}
                    />
                  ),
                },
              ]}
            />
          </div>
        </Col>
      </Row>
      </LoadState>
    </div>
  );
};

export default HomeownerOnboardingComponent;